/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_TitleInputs */



/**
* | output |
* | --- |
* | "Enter Caption File Name" |
*
* @param {Ateliere_Connect_Caption_Name_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_title = /** @type {((inputs?: Ateliere_Connect_Caption_Name_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisir le nom du fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie den Namen der Untertiteldatei ein")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome del file della didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название файла с субтитрами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el nombre del archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入标题文件名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションファイル名を入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन फ़ाइल का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o nome do arquivo de legenda")
	return /** @type {LocalizedString} */ ("Enter Caption File Name")
});